const mappingConfigs = {
  telemetry: {
    exclude: ["track_data"],
    rise: ["track_data", "vehicle_type"]
  },
  default: null
};

export const requestMapping = (data, layer_id) => {
  const mappingConfig = mappingConfigs[layer_id];
  if (!mappingConfig) return data;
  const newData = data.map(e => {
    mappingConfig.rise.forEach(k => {
      if (!e[k]) return;
      Object.keys(e[k]).forEach(l => {
        e[l] = e[k][l];
      });
    });
    mappingConfig.exclude.forEach(k => {
      delete e[k];
    });
    return e;
  });
  return newData.filter(e => e.geom);
};
